import React, { useState, useRef,useEffect } from 'react';
import Blocks_icon from '../../../../Assets/Images/password.png'
import { showToast } from '../../../../Component/Toast';
import Button from '../../../../Component/Button'

function Index(props) {
	const [timer,setTimer] = useState(30)
	const OTP = useRef()
    let Password = useRef(null), Confirm = useRef(null)
    const [PassStrength, setPassStrength] = useState(undefined);

    let strongPassword = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})')
    let mediumPassword = new RegExp('((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,}))')

    const submitForm = e => {

		let password = Password.current.value;
		let confirm = Confirm.current.value;

		if(!password){
			showToast({
				type: 'error',
				message: "Please enter Password"
			})
			return
		}
		if(!confirm){
			showToast({
				type: 'error',
				message: "Please Confirm Password"
			})
			return
		}
        if(confirm!==password){
			showToast({
				type: 'error',
				message: "Passwords do not match"
			})
			return
		}
        if(PassStrength==='WEAK'){
			showToast({
				type: 'error',
				message: "Choose a stronger Password (Min 8 Chars, Special Chars (@,#,.), Numbers"
			})
			return
		}
		let otp = OTP.current.value;
		if(!otp){
			showToast({
				type: 'error',
				message: "Enter a valid otp"
			})
			return
		}

        props.onSuccess(password,otp)

	}
	useEffect(()=>{
		let timeout = undefined;
		if(timer && timer>0){
			timeout = setTimeout(()=>{
				setTimer(timer-1)
			},1000)
		}
		return ()=>{
			if(timeout)
				window.clearTimeout(timeout)
		}
	},[timer])

    const checkStrength = (e) => {
        let pwd = e.target.value
        if(!pwd){
            setPassStrength(undefined)
        } else if (strongPassword.test(pwd)) {
            setPassStrength('STRONG')
        } else if (mediumPassword.test(pwd)) {
            setPassStrength('MEDIUM')
        } else {
            setPassStrength('WEAK')
        }
    }

    return (
        <>
       <div className="container" style={{height: '100vh'}}>
            <div className="row justify-content-center h-100-center">
                <div className="col-md-6 pt-6">
                    <div data-aos="fade-left" className="p-3 text-center" style={{backgroundColor: '#fff', borderRadius: '1rem', maxWidth: 400, boxShadow: '0 1rem 2rem rgba(0,0,0,.5)!important', margin: 'auto'}}>
                        <img className="img-fluid mb-4" src={Blocks_icon} alt='Lock' style={{maxWidth: 80}} />
                        <h1 className="display-6 fw-bold">Set Password</h1>
                        <p>Enter new password for your account</p>

                        <div className="mt-4 mb-4">
                            <div className='position-relative'>
								<input onChange={checkStrength} ref={Password} type="password" className="form-control mb-2" placeholder="Password" />
                                <div className='d-flex justify-content-start position-absolute' style={{top:0, right:0}}>
                                    {
                                        PassStrength==='WEAK'
                                        ?<div className="alert alert-danger" role="alert" style={{fontSize:'0.8rem', padding: '13px', textAlign:'left', display: 'inline-flex'}}>Weak Password</div>
                                        :PassStrength==='MEDIUM'
                                        ?<div className="alert alert-warning" role="alert" style={{fontSize:'0.8rem', padding: '13px', textAlign:'left', display: 'inline-flex'}}>Medium Password</div>
                                        :PassStrength==='STRONG'
                                        ?<div className="alert alert-success" role="alert" style={{fontSize:'0.8rem', padding: '13px', textAlign:'left', display: 'inline-flex'}}>Strong Password</div>
                                        :<></>
                                    }
                                </div>
                                <input ref={Confirm} type="password" className="form-control mb-3" placeholder="Confirm Password" />
								<input ref={OTP} type="text" className="form-control mb-4" placeholder="Enter OTP" />
								<p style={{
									fontSize:12,
									color:"#6367FA",
									textAlign:"left"
								}} className="text-small primary-color mt2">
									Password Policy: Password length should be minimum 8 characters with One upper case and one lower case and 1 special character and at least one number(0-9)
								</p>
								{
									timer>0 ?<p style={{textAlign:"left"}} className="mt2 w-100  fw-bold pointer">
											You can resend otp in {timer} seconds.
										</p>
										:<p style={{textAlign:"left"}}  className="mt2 w-100 fw-bold pointer" onClick={()=>{
											setTimer(30)
											props.onResend()
										}}>
											Resend Otp?
										</p>}
								<Button onClick={submitForm} name='Change Password' loading={false} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

export default Index;
